import {useMutation} from '@tanstack/react-query';
import {settingsService} from '@/services/settingsService';

// mutation keys
export const settingsMutationKeys={
    all: ['settings'],
    create: () => [...settingsMutationKeys.all, 'create'],
    update: () => [...settingsMutationKeys.all, 'update'],
    delete: () => [...settingsMutationKeys.all, 'delete'],
}

// create setting
export const useCreateSetting=()=>{
    return useMutation({
        mutationKey: settingsMutationKeys.create(),
        mutationFn: (settingData)=>settingsService.createSetting(settingData),
    })
}

// update setting
export const useUpdateSetting=()=>{
    return useMutation({
        mutationKey: settingsMutationKeys.update(),
        mutationFn: ({id: key, settingData})=>settingsService.updateSetting(key, settingData),
    })
}

// delete setting
export const useDeleteSetting=()=>{
    return useMutation({
        mutationKey: settingsMutationKeys.delete(),
        mutationFn: (key)=>settingsService.deleteSetting(key),
    })
}

